import { Outlet, useLocation, Navigate } from "react-router";
import { useAuth } from "./AuthContext";

const LogInSignUpProtectedRoute = () => {
  const { user, loading } = useAuth(); // Add loading state
  const location = useLocation();

  // If still loading, render nothing or a loading spinner
  if (loading) {
    return null; // Or return a loading spinner: <Spinner />;
  }

  // If user is not logged in, redirect to login
  if (user) {
    return <Navigate to="/account" state={{ from: location }} replace />;
  }

  // If user is logged in, render the protected route
  return <Outlet />;
};

export default LogInSignUpProtectedRoute;
